import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

// Layout components - lazy loaded for better code splitting
const LayoutNotifications = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/notifications/LayoutNotifications")
);
const LayoutSettings = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/settings/onTab/LayoutSettings")
);
// Template components - lazy loaded for better code splitting
const NotificationListingTemplate = lazy(
  () => import("~/templates/notifications/NotificationListingTemplate")
);

// Lazy load settings pages
const PageAccountSetting = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/settings/userSettings/PageAccountSetting")
);
const PageSettings = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/settings/onTab/PageSettings")
);
const PageSettingsBusinessWebsite = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/settings/onTab/PageSettingsBusinessWebsite")
);
const PageSettingsBilling = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/settings/onTab/PageSettingsBilling")
);
const PageSubscriptionReturn = lazy(
  () =>
    import("~/pages/providerWrapped/private/hasSidebar/settings/subscription/return")
);
const PageDocumentRedirect = lazy(
  () => import("~/pages/providerWrapped/forms/DocumentRedirect")
);
const PageStripeCheckoutReturn = lazy(
  () => import("~/pages/providerWrapped/forms/StripeCheckoutReturn")
);

export const notificationsRoutes: RouteObject = {
  path: "notifications",
  Component: LayoutNotifications,
  children: [
    {
      index: true,
      Component: NotificationListingTemplate,
    },
    {
      path: "read",
      element: <NotificationListingTemplate status="read" />,
    },
  ],
};

export const settingsRoutes: RouteObject[] = [
  {
    path: "settings/user-settings",
    Component: PageAccountSetting,
  },
  {
    path: "settings",
    Component: LayoutSettings,
    children: [
      {
        index: true,
        Component: PageSettings,
      },
      {
        path: "business-website",
        Component: PageSettingsBusinessWebsite,
      },
      {
        path: "billing",
        Component: PageSettingsBilling,
      },
    ],
  },
  {
    path: "settings/subscription/return",
    Component: PageSubscriptionReturn,
  },
  {
    path: "forms/document-redirect",
    Component: PageDocumentRedirect,
  },
  {
    path: "forms/stripe-checkout-return",
    Component: PageStripeCheckoutReturn,
  },
];
